import axios from "axios";
import _BaseAPIService from "../_BaseAPIService";

// Create axios instance with api4 base URL
const apiServiceInstance = axios.create({
  baseURL:
    window.APP_CONFIG?.api4?.baseapi ||
    "https://api-databasewebservice.danfesolution.com",
});

const AdService = {
  // Fetch ads from the API
  getAds: async (page = 1, pageSize = 10) => {
    try {
      const response = await apiServiceInstance.get("/api/itouch/ads", {
        params: {
          Page: page,
          PageSize: pageSize,
        },
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching ads:", error);
      throw error;
    }
  },
};

export default AdService;
